import { AppState } from '@/types';

export const createChallengeActions = (state: AppState, dispatch: any) => {
  const initializeChallenges = () => {
    dispatch({ type: 'INITIALIZE_CHALLENGES' });
  };

  const completeChallenge = (challengeId: string) => {
    dispatch({ type: 'COMPLETE_CHALLENGE', payload: { challengeId } });
  };

  const createCustomChallenge = (challengeData: any) => {
    // Mock implementation for now
    // Production: Remove console logs
  };

  const joinPublicChallenge = (challengeId: string) => {
    // Find the challenge in the marketplace (mock data for now)
    const publicChallenges = [
      {
        id: "pub_1",
        title: "30-Day Consistency Master",
        description: "Log at least one activity every day for 30 days straight",
        type: "daily_streak" as const,
        target: 30,
        progress: 0,
        reward: { points: 300, petItems: ["golden_collar", "consistency_crown"], title: "Consistency King" },
        startDate: new Date(),
        endDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
        status: "active" as const,
        difficulty: "hard" as const,
        category: "consistency",
        participantCount: 127,
        isPublic: true,
        isCustom: false,
        participants: [],
        participantProgress: {},
        invitations: [],
        maxParticipants: 500
      },
      {
        id: "pub_2", 
        title: "Weekend Warrior",
        description: "Earn 100 points during weekends only",
        type: "point_target" as const,
        target: 100,
        progress: 0,
        reward: { points: 75, petItems: ["weekend_badge"] },
        startDate: new Date(),
        endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
        status: "active" as const,
        difficulty: "medium" as const,
        category: "performance",
        participantCount: 89,
        isPublic: true,
        isCustom: false,
        participants: [],
        participantProgress: {},
        invitations: []
      }
    ];
    
    const challenge = publicChallenges.find(c => c.id === challengeId);
    if (challenge && state.user) {
      // Add user to participants and dispatch action
      const updatedChallenge = {
        ...challenge,
        participants: [...challenge.participants, state.user.id],
        participantProgress: { ...challenge.participantProgress, [state.user.id]: 0 }
      };
      dispatch({ type: 'JOIN_PUBLIC_CHALLENGE', payload: { challenge: updatedChallenge } });
    }
  };

  const inviteFriendToChallenge = (challengeId: string, friendId: string, message?: string) => {
    // Mock implementation for now
    // Production: Remove console logs
  };

  const acceptChallengeInvitation = (invitationId: string) => {
    // Mock implementation for now
    // Production: Remove console logs
  };

  const addChallengeFriend = (email: string) => {
    // Mock implementation for now
    // Production: Remove console logs
  };

  return {
    initializeChallenges,
    completeChallenge,
    createCustomChallenge,
    joinPublicChallenge,
    inviteFriendToChallenge,
    acceptChallengeInvitation,
    addChallengeFriend,
  };
};